import { Keep } from '@frontend/components/icons/outline'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { useSearchStore } from '@frontend/libs/stores/useSearchStore'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import logo from '@images/logo.png'
import { Button, ButtonGroup, cn, Image, Input } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { Link } from 'react-router-dom'

import MiniCartButton from '../shop/cart/MiniCartButton'
import { useScrollHandler } from './lib/hook'
import MobileMenuDrawer from './MobileMenuDrawer'

function NavigationMobile() {
  const { settings, siteInfo } = useSiteConfiguration()
  const { openModal } = useSearchStore((state) => state)
  const { headerVisible, isTop } = useScrollHandler()

  return (
    <header
      className={cn(
        'w-full bg-white py-8 shadow-sm transition-all delay-100 duration-300 ease-in-out',
        {
          '-translate-y-full transform': !headerVisible,
          'sticky left-0 top-0 z-50': !isTop,
        },
      )}
    >
      <div className="container space-y-4">
        <div className="flex justify-between gap-4">
          <Link to={siteInfo?.url || '/'}>
            <Image
              alt="Logo"
              classNames={{
                img: 'w-[215px]',
              }}
              src={settings?.logo || logo}
            />
          </Link>
          <ButtonGroup
            className="gap-2 [&>*]:w-auto [&>*]:min-w-0 [&>*]:p-0"
            variant="light"
          >
            <MiniCartButton />
            <Button as={Link} isIconOnly to="/wishlist">
              <Keep className="block h-10 w-10 !max-w-none text-transparent" />
            </Button>
            <MobileMenuDrawer />
          </ButtonGroup>
        </div>
        <Input
          classNames={{
            innerWrapper: 'bg-transparent',
            input: 'placeholder:uppercase',
            inputWrapper:
              'bg-transparent border border-primary rounded-3xl group-data-[focus=true]:bg-transparent',
          }}
          onClick={openModal}
          placeholder={__('What are you looking for?', 'asavagroup')}
          readOnly
          startContent={<MagnifyingGlassIcon className="h-5 w-5" />}
          type="search"
        />
      </div>
    </header>
  )
}

export default NavigationMobile
